import { create } from 'zustand';

type ReturnPathState = {
  paths: Record<string, string>;
  setPath: (key: string, value: string) => void;
  getPath: (key: string) => string | undefined;
};

const useReturnPathStore = create<ReturnPathState>((set, get) => ({
  paths: {},
  setPath: (key, value) =>
    set(state => ({
      paths: {
        ...state.paths,
        [key]: value,
      },
    })),
  getPath: key => get().paths[key],
}));

export default useReturnPathStore;
